export class GetValueAdditionDataBySkuCodesRequest {
    skuCodeId: number;
    constructor(skuCodeId: number) {
        this.skuCodeId = skuCodeId;
    }
}